module.exports = __webpack_public_path__ + "72111b1f02a78e95cdf763a39b22bee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1_variable/public/picture/Chinese.jpg
// module id = 371
// module chunks = 0